
import {
    defineComponent,
    ref,
    onMounted
} from "vue";
import cigoLayer from "@/components/cigo-layer/index";
import {
    TweenMax
} from "gsap";

export default defineComponent({
    name: "CigoLayerMsg",
    props: {
        layerIndex: {
            type: Number,
            default: ""
        },
        msg: {
            type: String,
            default: ""
        },
        timeout: {
            type: Number,
            default: 1
        }
    },
    setup(props) {
        onMounted(() => {
            delayShow();
        });

        const delayShow = () => {
            TweenMax.to("#layer-msg-content-" + props.layerIndex, 0.5, {
                opacity: 1,
                onComplete: () => {
                    delayHide();
                }
            });
        };

        const delayHide = () => {
            TweenMax.to("#layer-msg-content-" + props.layerIndex, 0.5, {
                opacity: 0,
                delay: props.timeout,
                onComplete: () => {
                    cigoLayer.close(props.layerIndex);
                }
            });
        };
        const clickMask = () => {
            delayHide();
        };

        return {};
    }
});
